import * as React from 'react';

const FileSendIcon = ({fillColor = '#424242'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={8.056} height={14.403}>
    <g data-name="Group 231353">
      <path
        data-name="Path 5707"
        d="M8.056 3.518a4.065 4.065 0 0 0-8.056 0v8.288a2.432 2.432 0 0 0 .884 1.85 3.169 3.169 0 0 0 2.077.747 2.8 2.8 0 0 0 2.961-2.6V4.439a1.571 1.571 0 0 0-.568-1.2 2.125 2.125 0 0 0-2.654 0 1.573 1.573 0 0 0-.568 1.205v6.442a.832.832 0 0 0 1.656 0V4.439a.139.139 0 0 1 .054-.107.321.321 0 0 1 .37 0 .14.14 0 0 1 .053.1v7.371a1.327 1.327 0 0 1-2.61 0V3.518a2.4 2.4 0 0 1 4.744 0v6.446a.832.832 0 0 0 1.656 0V3.518Z"
        fill={fillColor}
      />
    </g>
  </svg>
);
export default FileSendIcon;
